const cuttingTexts = window.themeStrings?.cutting || {};
console.log(cuttingTexts);

window.initCutCalculator = function(root) {
  if (!root || root.dataset.cutInit === 'true') return;
  root.dataset.cutInit = 'true';
  
   
  let messageCart = '';
  let custInAddedtoTheCart = 0;

  const calculator = root.querySelector('.calculator');
  const dataRows = root.querySelector('.js-data-rows');
  const addRowBtn = root.querySelector('.js-add-row');
  const finishBtn = root.querySelector('.js-finish');
  const messageEl = root.querySelector('.js-message');
  const productForm = root.querySelector('.js-product-form');
  //const quantityInput = root.querySelector('.js-quantity-input');
  const quantityInput = root.querySelector('.quantity-wrapper input'); // #quantity
  
  
  const shortNoteField = root.querySelector('.js-message-to-cutter-shortversion');
  const priceElement = root.querySelector('.additional-price');

  if (!productForm || !calculator || !dataRows || !addRowBtn || !finishBtn) return;

  const variantSkaeres = JSON.parse(root.querySelector('.js-variant-skaeres')?.textContent || '{}');
  const variantLengthMax = JSON.parse(root.querySelector('.js-variant-length-max')?.textContent || '{}');
  const variantYdelse = JSON.parse(root.querySelector('.js-variant-ydelse')?.textContent || '{}');

  console.log("variantSkaeres", variantSkaeres);
  console.log("variantLengthMax", variantLengthMax);
  console.log("variantYdelse", variantYdelse);  


  let currentVariantId = productForm.querySelector('[name="id"]')?.value;
  let maxLength = variantLengthMax[currentVariantId] || 6000;
  let skaere_ydelse = variantYdelse[currentVariantId] || '';

  function setMessage(html) {
    if (messageEl) messageEl.innerHTML = html;
  }

  function getCutListFromDataRows() {
    const cutList = [];
    dataRows.querySelectorAll('tr').forEach((row) => {
      const lengthInput = row.querySelector('input[name="length"]');
      const cutsInput = row.querySelector('input[name="cuts"]');
      if (lengthInput?.value && cutsInput?.value) {
        cutList.push({
          length: parseInt(lengthInput.value, 10),
          amount: parseInt(cutsInput.value, 10)
        });
      }
    });
    return cutList;
  }

  function addRow() {
    setMessage('');
    const row = document.createElement('tr');
    row.innerHTML = `
      <td><input type="number" name="cuts" min="1" value="1"></td>
      <td><input type="number" name="length" min="1" max="${maxLength}" value="100"><span class="calculator__sizeinfo">mm (max ${maxLength})</span></td>
      <td><button type="button" class="btn btn--secondary">${cuttingTexts.remove}</button></td>
    `;
    row.querySelector('button').addEventListener('click', () => {
      row.remove();
      calculateAndShowCust();
      console.log("REMOVE");
      
    });
    dataRows.appendChild(row);
  }

  function printResults(myCutList, myFinalList, myMaxCutLength) {
    let cutListString = '\n';
    let allPatternsWaste = 0;
    let allPatternsLength = 0;
    let cutNo = 0;

    for (let i = 0; i < myCutList.length; i++) {
      cutListString += `- ${myCutList[i].amount} stk x ${myCutList[i].length} mm.\n`;
    }

    for (let i = 0; i < myFinalList.length; i++) {
      let patternLength = 0;
      for (let j = 0; j < myFinalList[i].length; j++) {
        patternLength += myFinalList[i][j];
      }
      const patternWaste = myMaxCutLength - patternLength;
      allPatternsWaste += patternWaste;
      allPatternsLength += patternLength;
      cutNo++;
    }

    let totalCuts = 0;
    dataRows.querySelectorAll('tr').forEach((row) => {
      const cutsInput = row.querySelector('input[name="cuts"]');
      if (cutsInput?.value) totalCuts += parseInt(cutsInput.value, 10);
    });

    messageCart = `${cutListString} cuts ${totalCuts}`;
    custInAddedtoTheCart = totalCuts;

    if (quantityInput) quantityInput.value = cutNo;
    if (shortNoteField) shortNoteField.value = messageCart;

    setMessage(`<p><br>${cuttingTexts.calculatedlengths}: ${cutNo}<br>${cuttingTexts.calculatedcuts}: ${totalCuts}</p>`);
  }

  function algorithm(cutList, maxCutLength) {
    const patternList = [];
    const sumArray = [];

    for (let i = 0; i < cutList.length; i++) {
      let k = 0;
      let j = 0;
      while (j < cutList[i].amount) {
        if (sumArray[k] == null) sumArray[k] = 0;
        if (sumArray[k] + cutList[i].length <= maxCutLength) {
          patternList[k] = Array.prototype.concat(patternList[k], cutList[i].length);
          if (patternList[k][0] == null) patternList[k].shift();
          sumArray[k] += cutList[i].length;
          j++;
        } else {
          k++;
        }
      }
    }

    printResults(cutList, patternList, maxCutLength);
  }

  function calculateAndShowCust() {
    setMessage('');
    const cutList = getCutListFromDataRows();

    let allowedCuts = true;
    cutList.forEach((cut) => {
      if (cut.length > maxLength) {
        setMessage(`<span style="color:#990000;">Max ${maxLength}mm</span>`);
        allowedCuts = false;
      }
    });
    
    
    // FIX, reset after last row removed
    if (!cutList.length) {
      messageCart = '';
      custInAddedtoTheCart = 0;
    
      if (shortNoteField) shortNoteField.value = '';
      if (quantityInput) quantityInput.value = 1;
    
      return;
    }
    
    if (!allowedCuts) return;
    algorithm(cutList, maxLength);
    
    //if (!allowedCuts || !cutList.length) return;
    //algorithm(cutList, maxLength);
  }

  addRowBtn.addEventListener('click', addRow);
  finishBtn.addEventListener('click', calculateAndShowCust);

  root.addEventListener('on:variant:change', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    const currentVariantId = String(variant.id);
    //console.log("currentVariantId", currentVariantId);
    //console.log("variantSkaeres", variantSkaeres);

    const showCalculator = variantSkaeres[currentVariantId];
    
    //console.log("showCalculator", showCalculator);
    
    maxLength = variantLengthMax[currentVariantId] || 6000;
    skaere_ydelse = variantYdelse[currentVariantId] || '';

    calculator.classList.toggle('calculator--show', showCalculator === true);
    calculator.classList.toggle('calculator--hide', showCalculator !== true);

    if (priceElement) {
      priceElement.textContent = (variant.price / 100 * 0.8).toFixed(2).replace('.', ',');
    }
  });

  productForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    const parentVariantId = Number(productForm.querySelector('[name="id"]').value);
    const parentQty = Number(productForm.querySelector('[name="quantity"]').value || 1);
    const childVariantId = Number(skaere_ydelse);
    const childQty = Number(custInAddedtoTheCart || 0);

    const cutUid = 'cut-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);

    if (custInAddedtoTheCart === 0) messageCart = '';
    
    let payload;
        
    if (childVariantId && childQty > 0) {
      //console.log("HAS CUTS");
      
      payload = {
        items: [{
          id: parentVariantId,
          quantity: parentQty,
          properties: {
            Note: messageCart || '',
            _cut_uid: cutUid
          }
        }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      };
      
      payload.items.push({
        id: childVariantId,
        quantity: childQty,
        parent_id: parentVariantId,
        properties: {
          _is_cut_product: 'true',
          _cut_uid: cutUid
        }
      });
    } else {
      //console.log("HAS NO CUTS");
      
      payload = {
        items: [{
          id: parentVariantId,
          quantity: parentQty,
          properties: {
            Note: messageCart || ''            
          }
        }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      };
      
    }
    
    //console.log(payload);
    
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (!res.ok) throw data;

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
    } catch (err) {
      console.error('Cart error:', err);
    }
  }, true);
};



function initCuttingInScope(scope) {
  console.log("initCuttingInScope", scope);

  const roots = [];

  if (scope.matches && scope.matches('product-form.js-product')) {
    roots.push(scope);
  }

  roots.push(...scope.querySelectorAll('product-form.js-product'));

  roots.forEach((root) => {
    console.log("forEach", root);

    if (window.initCutCalculator) {
      console.log("initCutCalculator");
      window.initCutCalculator(root);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCuttingInScope(document);
});

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;

      if (node.matches('.quickbuy-container .inner, .quickbuy-container, product-form.js-product')) {
        initCuttingInScope(node);
      } else if (node.querySelector?.('product-form.js-product')) {
        initCuttingInScope(node);
      }
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});